import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-767ef313"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pb-3 fw-bold" }
const _hoisted_2 = ["data-bs-target"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus" }, null, -1))
const _hoisted_4 = {
  key: 0,
  class: "custom-tooltip px-2 py-1 rounded-2 bg-black text-white position-absolute"
}

import { translate } from '@/languages/i18n'


export default /*#__PURE__*/_defineComponent({
  props: {
  dataBsTarget: {
    type: String,
    default: '',
  },
  title: String,
  createPermission: {
    type: Boolean,
    default: true,
  },
  tooltip: {
    type: String,
    default: translate('makeGroup'),
  },
},
  emits: ['onClickPlusButton'],
  setup(__props, { emit }) {




const onClickPlusButton = () => {
  emit('onClickPlusButton')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([__props.dataBsTarget === '#createGroup' ? 'mt-30' : '', 'd-flex justify-content-center mb-lg-4 mb-3'])
  }, [
    _createElementVNode("h1", _hoisted_1, _toDisplayString(__props.title), 1),
    _createElementVNode("div", {
      class: _normalizeClass([__props.createPermission ? 'cursor-pointer' : 'inactive', 'add-icon position-relative rounded-circle ms-4 p-1 bg-white d-flex justify-content-center align-items-center']),
      "data-bs-toggle": "modal",
      "data-bs-target": __props.createPermission ? __props.dataBsTarget : '',
      onClick: onClickPlusButton
    }, [
      _hoisted_3,
      (__props.createPermission)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(__props.tooltip), 1))
        : _createCommentVNode("", true)
    ], 10, _hoisted_2)
  ], 2))
}
}

})